const init = {}

const orderHistoryReducer = (state = init, action) => {

    switch (action.type) {
        default: return state
    }
}

export default orderHistoryReducer